import { getLockId } from './getLockId';
import { getUpNextCalendarEvent, isUpNextScenarioInitialized } from 'owa-upnext-event-loader';
import { CalendarEvent } from 'owa-calendar-types';

export function getNowEvent(): CalendarEvent | null {
    const lockId = getLockId();
    return isUpNextScenarioInitialized(lockId) ? getUpNextCalendarEvent(lockId) : null;
}
